import { Check } from "lucide-react";

export const FormSection = ({ numero, titre, texte, children, testid }) => (
  <section className="border-t border-sand-dark pt-10 first:border-0 first:pt-0" data-testid={testid}>
    <div className="grid lg:grid-cols-[13rem_1fr] gap-7 lg:gap-12">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-terra">{numero}</p>
        <h2 className="font-serif text-2xl sm:text-3xl text-bark mt-2">{titre}</h2>
        {texte && <p className="text-sm text-fumee leading-relaxed mt-3">{texte}</p>}
      </div>
      <div className="min-w-0 space-y-7">{children}</div>
    </div>
  </section>
);

export const ChoiceGroup = ({ label, options, value, onChange, testid, multiple = false, columns = "sm:grid-cols-2" }) => {
  const active = (id) => multiple ? value.includes(id) : value === id;
  const choose = (id) => multiple
    ? onChange(active(id) ? value.filter((x) => x !== id) : [...value, id])
    : onChange(id);
  return (
    <fieldset>
      <legend className="eyebrow text-wood mb-3">{label}</legend>
      <div className={`grid ${columns} gap-2`} data-testid={`${testid}-options`}>
        {options.map(([id, text]) => (
          <button key={id} type="button" onClick={() => choose(id)} aria-pressed={active(id)} data-testid={`${testid}-${id}`}
            className={`min-h-12 flex items-center gap-3 rounded-lg border px-4 py-3 text-left text-sm transition-[border-color,background-color,transform] duration-300 hover:-translate-y-0.5 ${active(id) ? "border-terra bg-terra/10 text-bark" : "border-wood/20 bg-white/40 text-fumee hover:border-terra/70"}`}>
            <span className={`w-4 h-4 shrink-0 border flex items-center justify-center ${multiple ? "rounded-sm" : "rounded-full"} ${active(id) ? "border-terra bg-terra text-earth" : "border-wood/35"}`}>
              {active(id) && <Check className="w-3 h-3" />}
            </span>
            {text}
          </button>
        ))}
      </div>
    </fieldset>
  );
};

export const TextField = ({ label, testid, textarea = false, className = "", ...props }) => {
  const C = textarea ? "textarea" : "input";
  return (
    <label className={`block ${className}`}>
      <span className="eyebrow text-wood block mb-2">{label}</span>
      <C data-testid={testid} className="w-full min-h-12 bg-white/55 border border-wood/20 rounded-lg px-4 py-3 text-sm text-bark placeholder:text-fumee/60 focus:outline-none focus:border-terra transition-colors resize-y" {...props} />
    </label>
  );
};

export const InfoNote = ({ children, testid }) => (
  <p className="text-sm leading-relaxed text-fumee border-l-2 border-terra pl-4" data-testid={testid}>{children}</p>
);